<template>
	<div v-show="paypal_initialized">
		<div id="pp-btn"></div>
	</div>
</template>

<script>
	import braintree from 'braintree-web';
	import "../includes/paypal_checkout";

	export default {
		props: {
			braintree_token: {
				type: String,
				default: '',
			},
			environment: {
				type: String,
				default: 'production', //'production' : 'sandbox'
			},
			paypal_enabled: {
				type: Boolean,
				default: false,
			},
			paypal_credit_enabled: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				payPalInstance: null,
				paypal_initialized: false
			}
		},
		computed: {
			buttons_style() {
				return {
					// label: 'paypal', // checkout, credit, pay, buynow, paypal
					width: '250px',
					size: 'medium', // tiny, small, medium
					color: 'blue', // orange, blue, silver
					shape: 'rect',    // pill, rect
					layout: 'vertical' // horizontal, vertical
				}
			},
			disallowed_funding() {
				return this.paypal_credit_enabled ? [paypal.FUNDING.CARD] : [paypal.FUNDING.CARD, paypal.FUNDING.CREDIT];
			}
		},
		methods: {
			onPayment() {
				if (!this.payPalInstance) {
					this.$emit('error', 'PayPal instance not initialized');
					return;
				}
				this.$emit('click');
				return this.payPalInstance.createPayment({
					flow: 'vault'
				});
			},
			onAuthorize(data) {
				if (!this.payPalInstance) {
					this.$emit('error', 'PayPal instance not initialized');
					return;
				}
				this.payPalInstance.tokenizePayment(data).then(payment_token => {
					const payPalNonce = payment_token.nonce || null;
					this.$emit('tokenized', payment_token);
				}).catch(err => {
					this.$emit('error', err);
				})
			},
			onError(error) {
				this.$emit('error', error);
			},
			onCancel(data) {
				this.$emit('cancel', data);
			}
		},
		mounted() {
			if (!this.paypal_enabled && !this.paypal_credit_enabled) return;
			braintree.client.create({
				authorization: this.braintree_token
			}).then(braintreeClientInstance => {
				return braintree.paypalCheckout.create({
					client: braintreeClientInstance
				});
			}).then(payPalInstance => {
				this.payPalInstance = payPalInstance;
				paypal.Button.render({
					env: this.environment,
					style: this.buttons_style,
					funding: {
						disallowed: this.disallowed_funding
					},
					payment: this.onPayment,
					onAuthorize: this.onAuthorize,
					onError: this.onError,
					onCancel: this.onCancel
				}, '#pp-btn');
				this.paypal_initialized = true;
			}).catch(err => {
				this.$emit('error', err);
			});
		}
	}
</script>

<style lang="less">
	iframe.xcomponent-component-frame {
		z-index: auto !important;
	}
</style>